import React from "react";

import WidgetUpdate from "./widget-update";

interface Props {
  onClose?: any;
  entity: any;
  onSuccess?: any;
  onError?: any;
  arrayHelpers?: any;
  fields: any[];
}

function WidgetUpdateContainer(props: Props) {
  const { onClose } = props;

  const defaultValues = {
    interval: {},
    layout: {
      x: 0,
      y: 0,
      width: 12,
      height: 12,
    },
  };

  const { entity } = props;

  const { onSuccess /*, onError*/, arrayHelpers, fields = [] } = props;

  /*async*/ function saveEntity(values: any) {
    // const index = parentEntity.widgets.indexOf(entity);
    // parentEntity.widgets[index] = values;
    const index = fields.indexOf(entity);
    if (arrayHelpers) {
      arrayHelpers.update(index, values);
    } else {
      console.error("arrayHelpers does not exist!");
      fields[index] = values;
    }
    if (onSuccess) {
      onSuccess();
    }
    // return values;
  }

  return (
    <WidgetUpdate
      saveEntity={saveEntity}
      cancelEdit={onClose}
      entity={entity}
      defaultValues={defaultValues}
    ></WidgetUpdate>
  );
}

export default WidgetUpdateContainer;
